<template>
  <v-card rounded="xl" elevation="3">
    <v-card-title class="font-weight-bold">{{ title }}</v-card-title>
    <v-divider />
    <v-card-text>
      <FullCalendar :options="calendarOptions"/>
    </v-card-text>
  </v-card>
</template>

<script>

import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  name: 'EventCalendar',
  components: {
    FullCalendar
  },
  props: {
    title: {
      type: String,
      default: 'Event Calendar'
    },
    event: [],
    height: {
      type: [String, Number],
      default: 600
    }
  },

  data() {
    return {
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin
        ],
        initialView: 'dayGridMonth',
        height: this.height,
        selectable: false,
        editable: false,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        events: [
          {
            title: 'Employee Meeting',
            start: '2026-05-12T10:00:00',
            end: '2026-05-12T11:30:00',
            color: '#2563EB'
          },
          {
            title: 'Salary Processing',
            start: '2026-05-15T09:00:00',
            end: '2026-05-15T13:00:00',
            color: '#22C55E'
          },
          {
            title: 'Office Training',
            start: '2026-05-18T14:00:00',
            end: '2026-05-18T17:00:00',
            color: '#F59E0B'
          },
          {
            title: 'Performance Review',
            start: '2026-05-25T16:00:00',
            end: '2026-05-25T18:00:00',
            color: '#EF4444'
          },
          {
            title: 'Performance Review',
            start: '2026-05-25',
            color: '#EF4444'
          }
        ],

        eventClick(info) {
          alert(`Event: ${info.event.title}`)
        },
        dateClick(info) {
          console.log('Selected Date:', info.dateStr)
        }
      }
    }
  }
}

</script>
